export function buildChartTraces(dataset) {
    if (!dataset?.coverage_loss_simulations) return [];
    return dataset.coverage_loss_simulations.map((analysis) => {
        const yRaw = analysis.coverage_loss_row.prob_span_coverage_loss;
        return {
            x: yRaw.map((_, i) => i + 1),
            y: yRaw.map((v) => v * 100),
            name: String(analysis.n_sensor),
            mode: "lines",
            type: "scatter",
            hovertemplate: `Month %{x}<br>P(coverage loss): %{y:.1f}%<br>Sensors: ${analysis.n_sensor}<extra></extra>`,
        };
    });
}
